import DOMPurify from 'dompurify';

/**
 * Sanitiza HTML de FORMA LIVRE vindo de fora, para renderizar com `v-html`.
 *
 * ---------------------------------------------------------------------------
 * POR QUE EXISTEM TRÊS SANITIZADORES E NÃO UM
 * ---------------------------------------------------------------------------
 * Porque são três formatos com vocabulários diferentes, e um sanitizador só
 * para os três ou deixa passar demais num, ou come o conteúdo do outro:
 *
 *   sanitizeRichText    allowlist ESTREITA — o que o editor da casa produz.
 *                       Sem `img` de propósito: no fio de chamados imagem é
 *                       anexo com URL no Blob, não conteúdo embutido.
 *   sanitizeHtmlContent este arquivo. Perfil padrão do DOMPurify.
 *   sanitizeSvgIcon     perfil `svg` — ícones guardados no banco.
 *
 * ---------------------------------------------------------------------------
 * QUANDO USAR ESTE, E NÃO O `sanitizeRichText`
 * ---------------------------------------------------------------------------
 * Quando o HTML foi escrito FORA da nossa interface e a estrutura dele é parte
 * do conteúdo: corpo de chamado do Odoo, template de mensagem, termo de LGPD.
 * Esses textos legitimamente têm imagem, tabela e lista — passá-los pela
 * allowlist estreita entregaria um texto mutilado ao usuário, e mutilar
 * conteúdo em nome de segurança é trocar uma falha visível por uma invisível.
 *
 * O perfil padrão do DOMPurify já é a postura certa aqui: preserva HTML de
 * documento e remove o que executa — `<script>`, atributos `on*`, `javascript:`
 * em `href`, `<iframe>`, `<object>`.
 *
 * TESTE: veja a nota em `sanitizeRichText.ts` sobre `@vitest-environment jsdom`.
 * O environment padrão do vitest (happy-dom) não sanitiza direito, e um teste
 * escrito nele fica verde sem medir nada.
 */
export function sanitizeHtmlContent(html?: string | null): string {
  return DOMPurify.sanitize(String(html ?? ''));
}
